<template>
  <svg class="icon" viewBox="0 0 1024 1024" :width="size" :height="size">
    <path d="M937.2 851.5V599c-0.7-23.7-20.1-42.7-44-42.7s-43.3 19-44 42.7v217H178.5V599c-0.7-23.7-20.1-42.7-44-42.7s-43.3 19-44 42.7v252.5c0 28.9 23.6 52.5 52.5 52.5h741.8c28.8 0 52.4-23.6 52.4-52.5zM482.8 625.2c17.1 17.1 45.1 17.1 62.2 0l164-164c17.1-17.1 17.1-45.1 0-62.2s-45.1-17.1-62.2 0l-85.7 85.7V169.9c0-26-21.3-47.2-47.2-47.2-26 0-47.2 21.3-47.2 47.2v314.7L381 398.9c-17.1-17.1-45.1-17.1-62.2 0s-17.1 45.1 0 62.2l164 164.1z" ></path>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      default: '24'
    }
  }
}
</script>
